<template>
  <div 
    class="ItemsWrapper print:hidden print-hidden" 
    @click="toggle($event)"
  >
    <div 
      id="RightMenuMobile" 
      ref="RightMenuMobile"
    />
  </div>

  <div
    v-if="pageIsDocument || pageIsShareable || mobileMenuHasItems"
    class="ItemsPanel print:hidden print-hidden bg-white fixed bottom-3 rounded-lg left-3 right-3 flex lg:hidden px-4"
  >
    <div class="flex w-full items-center justify-between py-2">
      <div class="flex-shrink-0 space-x-4 text-left">
        <template v-if="pageIsDocument">
          <span
            @click="markit()"
            class="Markit | w-8 h-8 text-center inline-block md:hidden"
          >
            <span class="DocumentCircle"></span>
          </span>

          <span
            @click.stop.prevent="clickEditBtn"
            v-if="showEditBtn && !bcDocumentStore.edit"
            class="md:!ml-0"
          >
            <aw-icon icon="pen" class="w-8 h-8 text-red-600" />
          </span>
          <span
            @click.stop.prevent="clickPublishDocument"
            v-else-if="showPublishDocumentBtn && isActivePublishDocumentBtn"
            class="MobileFastAction"
            :class="{ muted: !isActivePublishDocumentBtn }"
          >
            <aw-icon
              icon="eye-opened"
              class="w-8 h-8 MobileFastActionIcon"
              :class="{ '!text-green-600': isActivePublishDocumentBtn }"
            />
          </span>
          <span
            @click.stop.prevent="clickEditBtn"
            v-else-if="bcDocumentStore.edit && !isActivePublishDocumentBtn"
            class="MobileFastAction"
          >
            <aw-icon
              icon="eye-opened"
              class="w-8 h-8 MobileFastActionIcon"
            />
          </span>
        </template>
      </div>

      <!-- <div class="flex-grow flex items-center justify-center">
        <span
          @click="toggle()"
          class="w-10 h-10 rounded-full text-white bg-bc-blue inline-flex justify-center items-center ring-1 ring-bc-blue ring-offset-4"
          >{{ buttonText }}</span
        >
      </div> -->

      <div class="flex-shrink-0 space-x-4 text-right">
        <!-- Share -->
        <span
          @click="clickShareBtn"
          v-if="pageIsShareable"
          class="MobileFastAction"
          :class="{ muted: !isActiveShareBtn }"
        >
          <aw-icon icon="share" class="w-8 h-8 MobileFastActionIcon" />
        </span>
        <!-- //Share -->

        <!-- Download -->
        <template v-if="pageIsDocument">
          <a
            :href="downloadableFiles[0].file.download_url.original"
            class="MobileFastAction"
            :class="{ muted: !isActiveDownloadBtn }"
            @click.stop.prevent="downloadFile"
            v-if="showDownloadBtn && downloadableFiles.length == 1"
          >
            <aw-icon icon="download" class="w-8 h-8"></aw-icon>
          </a>
          <span
            class="MobileFastAction"
            :class="{ muted: !isActiveDownloadBtn }"
            v-else-if="showDownloadBtn && downloadableFiles.length > 1"
            @click.stop.prevent="downloadZip"
          >
            <aw-icon icon="download" class="w-8 h-8"></aw-icon>
          </span>
        </template>
        <!-- //Download -->

        <span 
          v-if="mobileMenuHasItems"
          class="MobileFastAction"
          @click="toggle()"
          v-aw-driver-element="'ToggleMobileRightMenu'"
        >
          <aw-icon v-show="!show" icon="hamburger" class="w-8 h-8" />
          <aw-icon v-show="show" icon="close" class="w-8 h-8" />
        </span>
      </div>
    </div>
  </div>
  <div class="h-16 block lg:hidden ItemsPanelFiller print:hidden print-hidden"></div>
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import ShareButton from '../mixins/ShareButton'
import DownloadButton from '../mixins/DownloadButton'
import EditDocumentButton from '../mixins/EditDocumentButton'
import PublishDocumentButton from '../mixins/PublishDocumentButton'

export default {
  mixins: [
    ShareButton,
    DownloadButton,
    EditDocumentButton,
    PublishDocumentButton
  ],
  data() {
    return {
      show: false,
      mark: false,
      mobileMenuHasItems: false,
      rightMenuMobileObserver: null,
    }
  },
  methods: {
    checkMobileMenuItems() {
      if (this.$refs.RightMenuMobile.querySelector('a')) {
        this.mobileMenuHasItems = true
      } else {
        this.mobileMenuHasItems = false
      }
    },
    markit() {
      this.mark = !this.mark

      if (this.mark) {
        document.documentElement.classList.add('mobileCanBeMarked')
      } else {
        this.bcSelectedStore.resetSelected()
        document.documentElement.classList.remove('mobileCanBeMarked')
      }
    },
    toggle(ev) {
      if (
        ev &&
        ev.target.tagName === 'A' &&
        ev.target.getAttribute('href') === '#'
      ) {
        ev.stopPropagation()
      }

      this.show = !this.show

      if (this.show) {
        document.documentElement.classList.add('lock')
        document.body.classList.add('lock', 'ItemsMobile')
      } else {
        document.documentElement.classList.remove('lock')
        document.body.classList.remove('lock', 'ItemsMobile')
      }
    }
  },
  computed: {
    pageIsDocument() {
      return this.$route.matched[0].name === 'BCSharedDocument' || this.$route.matched[0].name === 'BCDocument'
    },
    pageIsShareable() {
      return this.showShareBtn && !this.$presenter.isPublic && (this.$route.matched[0].name === 'BCDocument' || this.$route.matched[0].name === 'BCFolder' || this.$route.matched[0].name === 'BCHome')
    },
    listSelected() {
      // FIXME: optimalize -> do not count children of color + table
      return this.bcSelectedStore.listFullySelected.filter(
        (el) => el.type !== 'color-row' && el.type !== 'table-row'
      )
    },
    buttonText() {
      return this.listSelected.length > 0 ? this.listSelected.length : ''
    },
    ...mapStores(useBcSelectedStore)
  },
  mounted() {
    document.documentElement.classList.remove('mobileCanBeMarked')
    this.rightMenuMobileObserver = new MutationObserver(this.checkMobileMenuItems)
    this.rightMenuMobileObserver.observe(this.$refs.RightMenuMobile, { childList:true })
  },
  beforeUnmount() {
    this.rightMenuMobileObserver.disconnect()
  },
}
</script>

<style lang="scss">
[device-desktop='0'] {
  .Markit {
    @apply hidden;
  }
}

.ItemsMobile {
  .ItemsWrapper {
    transform: scale(1);
    transition: transform 0ms;
  }

  .ItemsWrapper > div {
    transform: translateY(calc(-2.05 * env(safe-area-inset-bottom) - 56px));
    opacity: 1;
    transition: transform 200ms 150ms, opacity 200ms 150ms;
  }
}

.ItemsWrapper {
  @apply bg-black bg-opacity-70 fixed  left-0 right-0;
  @apply flex items-end justify-end;
  @apply pb-4 px-4 pr-3;
  z-index: 500;
  top: 40px;
  //bottom: calc(2.05 * env(safe-area-inset-bottom) + 56px); // ponechat!
  bottom: 0;

  transform: scale(0);
  transition: transform 1ms 350ms;
}

.ItemsWrapper > div {
  @apply bg-white p-5 rounded-md;
  @apply w-full;
  @apply space-y-3;
  @apply overflow-y-auto;
  max-width: 300px;
  max-height: 90%;
  transform: translateY(200%);
  opacity: 0;
  transition: transform 200ms 100ms, opacity 200ms 100ms;

  > div[data-driver-element], > div[data-driver-element] > div[data-driver-element] {
    @apply space-y-3;
  }
}

.ItemsWrapper > div:not(div[data-driver-element]) > a,
.ItemsWrapper > div > div[data-driver-element] > div[data-driver-element] > a,
.ItemsWrapper > div > div[data-driver-element] > a {
  @apply flex items-center;

  svg {
    @apply mr-2;
  }

  &.muted {
    pointer-events: none;
    @apply text-gray-400;

    &:hover {
      @apply text-gray-400;
    }
  }
}

.MobileFastAction {
  @apply text-gray-400;
  > .MobileFastActionIcon {
    @apply text-gray-400;
  }

  &.muted {
    pointer-events: none;
    > .MobileFastActionIcon {
      @apply text-gray-400;
    }
  }
}

.ItemsPanel {
  z-index: 501;
  box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px,
    rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;
  margin-bottom: calc(2.05 * env(safe-area-inset-bottom));
  transition: 100ms padding ease-in-out;
}

.ItemsPanelFiller {
  padding-bottom: calc(2.05 * env(safe-area-inset-bottom));
}
</style>